import {Divider, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import {Skeleton} from "@material-ui/lab";
import MainOfferContent
    from "../../../../../../../../../../shared/components/dialogs/change-plan-by-sim-dialog/main/main-offer-content/MainOfferContent";
import {getRandomNumber} from "../../../../../../../../../../shared/utils/utils";
import GrayHeaderCard from "../../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";

const DettaglioPianoCard = (props) => {
    const currentOffer = useSelector(state => state.contrattoDigitaleReducer.currentOffer.data)
    const currentOfferLoading = useSelector(state => state.contrattoDigitaleReducer.currentOffer.loading)
    const offerteDetails = useSelector(state => state.ordiniConsipReducer.offerteRowDetails.data)
    const offerteLoading = useSelector(state => state.ordiniConsipReducer.offerteRowDetails.loading)
    let offerData = props.isFromConsip ? offerteDetails : currentOffer;

    return (
        <GrayHeaderCard title={
            <Typography variant="subtitle2">
                Dettaglio {props.arePianoDetails ? 'piano' : 'opzione'}
            </Typography>
        }>
            <>
                <Box my='2em'>
                    <Typography variant='h5'>{props.planName}</Typography>
                </Box>
                <Divider/>
                <Box my='2em'>
                    <Typography variant='body2'>
                        {currentOfferLoading ?
                            <Skeleton height={`${getRandomNumber(75, 150)}px`} animation='wave'/> :
                                offerData.planDescription
                        }
                    </Typography>
                </Box>
                {currentOfferLoading || offerteLoading ?
                    <Skeleton height={`${getRandomNumber(150, 320)}px`} animation='pulse' variant='rect'/> :
                    <MainOfferContent zoneData={offerData.offertaZoneItemList}
                                      planName={offerData.offertaZoneItemList.length !== 0 ? "Piano Base" : ""}
                                      isOpzioni={!props.arePianoDetails}/>}
                <Box my='2em'>
                    <Typography variant={"overline"}
                                color={"textSecondary"}>
                        SUPERAMENTO DELLE SOGLIE
                    </Typography>
                </Box>
                <Typography variant='body2'>
                    Al superamento delle eventuali soglie incluse nel Piano Base,
                    la tariffazione sarà a consumo (con tariffazione definita nel contratto),
                    salvo quanto indicato nelle opzioni e gettoni attive nel paragrafo <b>“Opzioni e gettoni
                    attivi”.</b>
                </Typography>

            </>
        </GrayHeaderCard>
    )
}

DettaglioPianoCard.propTypes = {
    planName: PropTypes.string,
    arePianoDetails: PropTypes.bool.isRequired
}

export default DettaglioPianoCard
